import _ from "lodash";
import * as React from "react";

interface IProps {
    tags: any[];
}

export default ({ tags }: IProps) => {
    return !_.isEmpty(tags) ?
        <div className="NR_tags">
            <div className="CMS_title CMS_T6">
                <em className="fa fa-tags"></em> Tags
            </div>
            {_.map(tags, (tag, index) => (
                <React.Fragment key={index}>
                    {index ? (
                        <span className="NR_tag_sep">, </span>
                    ) : ""}
                    <span className="NR_tag">{tag}</span>
                </React.Fragment>
            ))}
        </div> : null;
};
